import { Query, QueryClient, QueryKey } from "@tanstack/react-query"

export const invalidateCompanySetupInfoQueries = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    predicate: (query: Query<unknown, unknown, unknown, QueryKey>) =>
      typeof query.queryKey[0] === "string" &&
      query.queryKey[0].startsWith("/account/getcompanysetupinfo"),
  })
}
